const listViewModes = {
  THUMB: 'THUMB',
  TABLE: 'TABLE'
};

export default listViewModes;